<div class="jumbotron">
    <h1 class="display-4 text-center">About github Website</h1>
    <hr class="my-4">
    <p class="lead text-center">An Angular app that let's you search github repositories from the world of computing!</p>
  </div>